module.exports = __webpack_public_path__ + "img/bg-pattern-decorative.8fdbea30.png";